import { useMutation } from "react-query";
import { mutation } from "../state/appQueryClient";
import { useIdle, useInterval } from "react-use";

const REFRESH_INTERVAL = 2 * 60 * 60 * 1000; // 2 hours
const IDLE_INTERVAL = 60 * 60 * 1000; // 1 hour

export const useRefreshToken = () => {
  const tokenMutation = useMutation(
    () => {
      return mutation({
        queryKey: [
          "refreshToken",
          {
            action: "refreshToken",
            enabled: true,
          },
        ],
      });
    },
    {
      onSuccess: () => {},
    }
  );

  const isIdle = useIdle(IDLE_INTERVAL);
  useInterval(() => {
    if (!isIdle && !tokenMutation.isLoading) {
      tokenMutation.mutate();
    }
  }, REFRESH_INTERVAL);
};
